import React from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./styles.css";

const ThankyouPage = ({ history }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { timeclock, timeClockType } = location.state || {};

  const capitalizeWords = (str) => {
    return str !== null ? str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
      .join(" ") : '';
  };

  return (
    <React.Fragment>
      <div className="timeclock__thankyou-container">
        {timeclock ? (
          <>
            <h4>{moment(timeclock).format("HH:mm")}</h4>
            <p>
              {timeClockType == "clock in"
                ? t("Clock In")
                : timeClockType == "clock out"
                ? t("Clock Out")
                : timeClockType == "break in"
                ? t("Break In")
                : timeClockType == "break out"
                ? t("Break Out")
                : capitalizeWords(timeClockType)}
              !
            </p>
          </>
        ) : (
          <p>{t('No Data Found')}</p>
        )}
        <button
          type="button"
          className="btn btn-design btn-brand btn-clockinout"
          style={{
            backgroundColor: "#4BA6EF",
          }}
          onClick={() => {
            history.push("/time-clock");
          }}
        >
          {t('Back to Timeclock')}
        </button>
      </div>
    </React.Fragment>
  );
};

export default ThankyouPage;
